import {defineStore} from 'pinia';
import {ModuleJusticeDecision} from '../moduleConst';
import justiceDecisionAPI from '@/apis/di/justiceDecisionAPI';
import { BaseDictionaryStore } from '@/stores/baseDictionaryStore';
import indexedDB from '@/commons/indexedDB';
const justiceDecisionStore = new BaseDictionaryStore(justiceDecisionAPI);
export const useJusticeDecisionStore = defineStore(ModuleJusticeDecision, {
  state: () => ({
    ...justiceDecisionStore.state,
    _config: {
      key: 'justice_decision_id',
      code: 'justice_decision_alias',
      name: 'justice_decision_name',
      table: 'di_justice_decision',
      quickFollow: 'active',
      moduleName: 'Quyết định thi hành án',
      defaultSort: 'justice_decision_alias',
    },
    moduleName: 'diJusticeDecision',
    detailData: [],
  }),
  actions: {
    ...justiceDecisionStore.action,
    /**
     * Xử lý load dữ liệu cache danh mục
     */
    async loadFullCache(payload) {
      const config = this._config;
      const name = `di_cache_${this.$id}`;

      // Kiểm tra xem module này cấu hình cache hay ko
      const indexDb = new indexedDB();
      const key = name;
      const data = await indexDb.get(key);
      if (data) {
        const {localVersion, localData} = data;
        // Nếu version khác nhau thì thực hiện load lại full dữ liệu
        if (localVersion !== payload.remoteVersion) {
          const remoteData = await this.getFullListCustom();

          await indexDb.set(key, {
            localVersion: payload.remoteVersion,
            localData: remoteData,
          });
          this.items = remoteData.masterData;
          this.detailData = remoteData.detailData;
        } else {
          this.items = localData.masterData;
          this.detailData = localData.detailData;
        }
      } else {
        const remoteData = await this.getFullListCustom();
        await indexDb.set(key, {
          localVersion: payload.remoteVersion,
          localData: remoteData,
        });
        this.items = remoteData.masterData;
        this.detailData = remoteData.detailData;
      }

      this.executeAfterLoadFullCache();
    },
  },
  getters: {
    ...justiceDecisionStore.getters,
  },
});
